import { assessmentEnabled, hasPermissionGuard } from '@app/core/guards';
import { AddStudentComponent } from './add-student/add-student.component';
import { EditStudentComponent } from './edit-student/edit-student.component';
import { CourseCompletedComponent } from './course-completed/course-completed.component';
import { UploadAssessmentComponent } from './upload-assessment/upload-assessment.component';
import { ModalComponent } from './modal.component';

const routes = [
    {
        path: 'add-student',
        component: ModalComponent,
        outlet: 'modal',
        canActivate: [hasPermissionGuard('admin.access')],
        children: [
            {
                path: '',
                component: AddStudentComponent,
            },
        ],
    },
    {
        path: 'edit-student',
        component: ModalComponent,
        outlet: 'modal',
        canActivate: [hasPermissionGuard('admin.access')],
        children: [
            {
                path: '',
                component: EditStudentComponent,
            },
        ],
    },
    {
        path: 'course-completed',
        component: ModalComponent,
        outlet: 'modal',
        children: [
            {
                path: '',
                component: CourseCompletedComponent,
            },
        ],
    },
    {
        path: 'upload-assessment',
        component: ModalComponent,
        outlet: 'modal',
        canActivate: [assessmentEnabled()],
        children: [
            {
                path: '',
                component: UploadAssessmentComponent,
            },
        ],
    },
];

export { routes as modalRoutes };
